import React, { Component } from 'react';
import { Container, Row, Col, Card } from 'reactstrap';
import { NavMenu } from './NavMenu';
import Footer from "./Footer.js";
import SideBar from './SideBar.js';
import StickyBox from "react-sticky-box";
import "react-pro-sidebar/dist/css/styles.css";

const styles = {
    contentDiv: {
        display: "flex",
    },
    contentMargin: {
        marginLeft: "10px",
        width: "100%",
    },
};

/*PRUEBA stiky style = {{ display: "flex", alignItems: "flex-start" }}*/

export class Layout extends Component {
    static displayName = Layout.name;

    render() {        
      return (
          <div className='wrapper'>
            <Row>
                <Col>
                    <NavMenu />
                </Col>
            </Row>
           {/* <Row>*/}
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <StickyBox offsetTop={20} offsetBottom={20} >
                          <SideBar />
                  </StickyBox>
                <div style={styles.contentMargin}>
                      <div style={{ paddingRight: "5vw" , minHeight: '72vh'}}>
                        {this.props.children}
                      </div>
                </div>
              </div>
            {/*</Row>*/}
            <div>
                <p style={{
                    color: "#ffffff",
                    textAlign: "center",
                    fontSize: '0.65em',
                    background: '#233364',                    
                    left: 0,
                    bottom: 0,
                    right: 0,
                    marginBottom: 0,
                }}>
                    Escuela Superior Polit&eacute;cnica del Litoral - Campus Gustavo Galindo - Guayaquil - Ecuador
                    <br />
                    &#169; El contenido de esta obra es de propiedad de la ESPOL. Todos los derechos reservados.
                    <br />
                    Prohibida su reproducci&oacute;n total o parcial, comunicaci&oacute;n p&uacute;blica o distribuci&oacute;n sin autorizaci&oacute;n previa del titular de los derechos.
                </p>
            </div>
      </div>
    );
  }
}
